const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20scene%20with%20warm%20crimson%20and%20gold%20lighting%2C%20abstract%20breaking%20news%20concept%2C%20dramatic%20spotlight%20on%20stage%2C%20editorial%20photography%20style%20with%20rich%20contrast&width=1200&height=600&seq=carousel-feature-01&orientation=landscape',
    title: '2026 娱乐圈年中大盘点',
    desc: '上半年娱乐圈大事记：塌房、结婚、复出、退圈...过去6个月，娱乐圈发生了哪些惊天动地的大事？一文带你回顾。',
    tag: '年度策划',
    count: '28篇专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20live%20streaming%20studio%20with%20vibrant%20warm%20atmosphere%2C%20ring%20light%20glow%2C%20abstract%20digital%20influencer%20scene%2C%20editorial%20quality%20with%20dramatic%20shadows&width=1200&height=600&seq=carousel-feature-02&orientation=landscape',
    title: '网红圈乱象深度调查',
    desc: '直播带货数据造假、粉丝量水分惊人、MCN机构内幕大揭秘...网红经济的真相，比你想象的更触目惊心。',
    tag: '深度调查',
    count: '15篇专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20film%20premiere%20event%20with%20red%20carpet%20and%20flashing%20cameras%2C%20golden%20warm%20lighting%2C%20abstract%20cinematic%20celebration%2C%20editorial%20photography&width=1200&height=600&seq=carousel-feature-03&orientation=landscape',
    title: '暑期档大片前瞻特辑',
    desc: '2026暑期档最值得关注的影视作品全解析，演员阵容、制作内幕、票房预测，你想知道的都在这里。',
    tag: '影视前瞻',
    count: '22篇专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Abstract%20social%20media%20feed%20visualization%20with%20glowing%20notification%20icons%2C%20warm%20crimson%20and%20amber%20gradient%2C%20digital%20news%20aggregation%20concept%2C%20editorial%20style&width=1200&height=600&seq=carousel-feature-04&orientation=landscape',
    title: '吃瓜入门：新人必读指南',
    desc: '刚来每日爆料？这份吃瓜指南帮你快速上手：了解圈内黑话、掌握吃瓜礼仪、学会辨别真假爆料，从此吃瓜不迷路。',
    tag: '新手必读',
    count: '10篇专题',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-18 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-2">焦点专题</h2>
        <p className="text-foreground-500 text-sm text-center mb-8">编辑团队精心策划的深度专题报道</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group relative bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-foreground-900/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded text-[11px] font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-background-100/80">{item.count}</span>
                </div>
                <h3 className="text-lg font-bold text-background-50 font-heading leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-background-100/70 mt-2 line-clamp-2 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}